var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"panel"},[_c('div',{staticClass:"add",on:{"click":_vm.add}},[_vm._v("添加项目")])]),_vm._l((_vm.data),function(item,index){return _c('div',{key:index},[_vm._t("default",null,{"item":item,"index":index})],2)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }